module.exports = __webpack_public_path__ + "static/media/ost_3.1bba2df3.png";


//////////////////
// WEBPACK FOOTER
// ./src/presentation/assets/img/ost_3.png
// module id = 1043
// module chunks = 0